module.exports = __webpack_public_path__ + "static/Inter-Regular-3ae6a7d3890c33d857fc00bd2e4c4820.woff";